import { render, staticRenderFns } from "./TicketSidebar.vue?vue&type=template&id=1ed7efa1"
import script from "./TicketSidebar.vue?vue&type=script&lang=js"
export * from "./TicketSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports